var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessengerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 10.8334L9.16667 9.1667L10.8333 10.8334L13.3333 9.1667M2.5 16.6667L3.58333 13.4167C2.64704 12.0319 2.30833 10.392 2.63018 8.80194C2.95204 7.21185 3.91255 5.77975 5.33314 4.77192C6.75373 3.76409 8.53772 3.24911 10.3534 3.32273C12.1691 3.39634 13.8929 4.05355 15.2044 5.17216C16.5159 6.29076 17.3257 7.79464 17.4834 9.40418C17.6411 11.0137 17.1358 12.6194 16.0616 13.9226C14.9873 15.2259 13.4172 16.138 11.6432 16.4895C9.86911 16.8409 8.01184 16.6078 6.41667 15.8334L2.5 16.6667Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessengerIcon);
export default __webpack_public_path__ + "static/media/MessengerIcon.3ae7359a819650536870dd8388b27199.svg";
export { ForwardRef as ReactComponent };